import * as React from "react";
import { Box, Layout, Text, Flex } from "@draftkings/arena-web";
export const OddsBoost = React.memo(function OddsBoost(props) {
    const { label, status, messages, purchaseId, testId } = props;
    return React.createElement(Layout, { variant: "bonus" },
        React.createElement(Flex, { gap: "8px", alignItems: "center", marginRight: "auto" },
            React.createElement(Box, { testId: testId, variant: `button.betBoost:${status}` }, label)),
        messages.map((message, index) => React.createElement(Text, { key: `${purchaseId}-${index}`, testId: `message-${purchaseId}-${index}`, variant: `boostMessage${message.type}` }, message.text)));
});
//# sourceMappingURL=OddsBoost.js.map